import { useEffect, useState } from "react";


function parseQueryString(queryString) {
  // 解析 query string
  const params = queryString
    .split(/\?|&/g)
    .filter((item) => item.length > 0)
    .reduce((acc, item) => {
      const [key, value] = item.split('=');
      if (value === 'true' || value === 'false') {
        acc[key] = Boolean(value);
      }
      else if (value.match(/^(-)?[1-9]\d*$/)) {
        acc[key] = Number(value);
      }
      else {
        acc[key] = value;
      }
      return acc;
    }, {});

  return params;
}

function parseCustomDataString(targetString) {
  const params = targetString
    .split(',')
    .filter((item) => item.length > 0)
    .reduce((acc, item) => {
      const [key, value] = item.split('@');
      if (value === 'true' || value === 'false') {
        acc[key] = Boolean(value);
      }
      else if (value.match(/^(-)?[1-9]\d*$/)) {
        acc[key] = Number(value);
      }
      else {
        acc[key] = value;
      }
      return acc;
    }, {});
  return params;
}


/**
 * 
 * @param options 
 * @returns **isMounted** | if the component is mounted
 * @returns **customData** | custom data
 * @returns **isAction** | if the mgm action is happened
 * @returns **isFriendshipStatusChanged** | if the friendship status is changed */
export function useLineMgmParams(options) {
  const { disabled = false, debug = false } = options;
  const [isMounted, setIsMounted] = useState(false);

  const [result, setResult] = useState({
    customData: {},
    isAction: false,
    isNewFriend: false,
  });

  useEffect(() => {
    if (disabled) {
      return;
    }

    try {
      // quueryString 可能會長得像是這樣
      // ?_target_url=https://liff.line.me/2004306727-jlMmamwo?custom_data=uid@1,pslug@test-12&code=Df16lcRhmS3WQp1oeNNq&state=0&friendship_status_changed=true
      const queryString = decodeURIComponent(decodeURIComponent(window.location.search ?? ''));
      console.log(debug, 'mgm query string: ', queryString);


      // 解析 query string
      const params = parseQueryString(queryString);  
      if (params['code'] === undefined && params['friendship_status_changed'] === undefined) {
        setResult({
          isAction: false,
          isNewFriend: false,
          customData: {},
        });
        return;
      }

      let isNewFriend = false;
      if (params['friendship_status_changed']) {
        isNewFriend = true;
      }
  
      // 解析 custom data
      const customData = parseCustomDataString(params['custom_data'] ?? '');
      
      console.log(debug, 'custom data: ', customData);
      setResult({
        isAction: true,
        isNewFriend,
        customData,
      });
    }
    catch {
      console.error('save mgm action failed');
    }
    finally {
      setIsMounted(true);
    }
  }, [disabled, debug]);

  return { isMounted, ...result };
}
